<template>
  <div class="h-max rounded px-1 text text-2xs text-white leading-5">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'GrmMark',
}
</script>